import { Checkbox } from "../Checkbox";
import { Icon } from "../Icon/icon";
import { Option } from "./Dropdown";
import stylesheet from "./Dropdown.module.scss";

interface DropdownMenuItemProps {
  option: Option;
  isMulti?: boolean;
  isSelected: boolean;
  isHighlighted?: boolean;
  isLocked?: boolean;
  dark?: boolean;
  onClick: (option: Option) => void;
  onMouseEnter?: () => void;
  navIndex?: number;
}

export function DropdownMenuItem({
  option,
  isMulti,
  isSelected,
  isHighlighted = false,
  isLocked = false,
  dark,
  onClick,
  onMouseEnter,
  navIndex,
}: DropdownMenuItemProps) {
  return (
    <li
      key={option.value}
      role="option"
      aria-selected={isHighlighted}
      data-nav-index={navIndex}
      className={`
        ${stylesheet.dropdownOption} 
        ${isHighlighted ? stylesheet.highlighted : ""} 
        ${isSelected ? stylesheet.selected : ""}
        ${isLocked ? stylesheet.locked : ""}
      `}
      style={
        isMulti
          ? {
              paddingLeft:
                "calc(var(--wlcm-spacing-sm) + var(--wlcm-spacing-md))",
            }
          : {}
      }
      onClick={() => !isLocked && onClick(option)}
      onMouseEnter={onMouseEnter}
    >
      {isMulti ? (
        <Checkbox
          label={option.label}
          hideLabel
          dark={dark}
          checked={isSelected}
          disabled={isLocked}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!isLocked) onClick(option);
          }}
        />
      ) : (
        option.icon && <Icon name={option.icon} className={stylesheet.icon} />
      )}
      <span aria-hidden={isMulti}>{option.label}</span>
    </li>
  );
}
